import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useSelector } from "react-redux";

import FbIconImg from "../assets/images/provider/facebook.png";
import InstaIconImg from "../assets/images/provider/instagram.png";
import logo from "../assets/images/logoNew.webp";
import AppuGames from "../assets/images/provider/Betfair.jpg";
import EvolutionGames from "../assets/images/provider/provider-logo-evolution.png";
import EzugiGames from "../assets/images/provider/provider-logo-ezugi.png";

import binance from "../assets/images/payments/new/Binance.png";
import pmicon from "../assets/images/payments/new/Pm.png";
import therthnt from "../assets/images/payments/new/Tether.png";
import Bitcoin from "../assets/images/payments/new/Bitcoin.png";
import Phonepay from "../assets/images/payments/new/phonepe-logo-icon.png";
import Paytm from "../assets/images/payments/new/Paytm.png";
import GooglaPay from "../assets/images/payments/new/Gpay.png";
import UPIcon from "../assets/images/payments/new/Upi.png";

import Calling1 from "../assets/images/icons/phone.png";
import Whatapps from "../assets/images/icons/whatsapp.png";
import Telegram from "../assets/images/icons/telegram.png";
import Mail from "../assets/images/icons/mail.png";

import WhatsaPPImg from "../assets/images/icons/whatsappfoot.png";
import TelegramImg from "../assets/images/icons/telegramfoot.png";
import BottomNav from "./BottomNav";

import SecurePartner from "../assets/images/icons/secure.png";

import downloadApp from "../assets/images/icons/download-android-app-icon.svg";

import Payments11 from "../assets/images/icons/footer/Upay.png";
import Payments9 from "../assets/images/icons/footer/payment-9.png";
import Payments8 from "../assets/images/icons/footer/payment-8.png";
import Payments7 from "../assets/images/icons/footer/Nagad.png";
import Payments6 from "../assets/images/icons/footer/Bkash.png";
import Payments5 from "../assets/images/icons/footer/payment-5.png";
import Payments4 from "../assets/images/icons/footer/payment-4.png";
import Payments3 from "../assets/images/icons/footer/payment-3.png";
import Payments2 from "../assets/images/icons/footer/payment-2.png";
import Payments1 from "../assets/images/icons/footer/payment-1.png";

const Footer = () => {
  const { appDetails } = useSelector((state) => state.app);

  return (
    <>
      <div className="SocialMediaSection">
        <Container>
          <ul>
            <li>
              <a href={`tel://${appDetails?.PHONE}`}>
                <img src={Calling1} alt="Calling icon" />
                <span>+91 98765 43210</span>
              </a>
            </li>
            <li>
              <a href="mailto:info.mmplay@gmail.com">
                <img src={Mail} alt="Calling icon" />
                <span>info.mmplay@gmail.com</span>
              </a>
            </li>
            <li>
              <a
                href={
                  appDetails?.WHATS_APP_URL != ""
                    ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
                    : "javascript:void(0)"
                }
                target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
              >
                <img src={Whatapps} alt="Calling icon" />
                <span>Whatsapp</span>
              </a>
            </li>
            <li>
              <a
                href={
                  appDetails?.TELEGRAM != ""
                    ? appDetails?.TELEGRAM
                    : "javascript:void(0)"
                }
                target={appDetails?.TELEGRAM != "" ? "_blank" : ""}
              >
                <img src={Telegram} alt="Calling icon" />
                <span>Telegram</span>
              </a>
            </li>
          </ul>
        </Container>
      </div>

      <footer className="footer">
        <Container>
          <div className="DownloadApp">
            <a href="javascript:void(0)">
              <img src={downloadApp} alt="downloadApp" />
            </a>
          </div>
          <div className="footer-links">
            <Container>
              <Row>
                <Col xs={12}>
                  <ul>
                    <li>
                      <a href="/contact">Contact Us</a>
                    </li>
                    <li>
                      <a href="/privacypolicy">Privacy Policy</a>
                    </li>

                    <li>
                      <a href="/ResponsibleGaming">Responsible Gaming</a>
                    </li>
                    <li>
                      <a href="/fairplay">Fair Play</a>
                    </li>
                    <li>
                      <a href="/gamerules">Games Rules</a>
                    </li>
                    <li>
                      <a href="/termsandcondition">Terms and Conditions</a>
                    </li>
                  </ul>
                </Col>
              </Row>
            </Container>
          </div>
          <div className="WhatsappID">
            <li>
              <a
                href={
                  appDetails?.WHATS_APP_URL != ""
                    ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
                    : "javascript:void(0)"
                }
                target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
              >
                <img src={Whatapps} alt="Calling icon" />
                <span>Get Your ID</span>
              </a>
            </li>
          </div>
          <div className="LogoDescription">
            <div className="container">
              <ul>
                <li>
                  <a href="#">
                    <img src={appDetails?.LOGO_URL || logo} alt="Logo" />
                  </a>
                </li>
                <p>
                  We are dedicated to making sure you have a great time playing
                  games on Betio365 while also being well aware of the negative
                  social and financial implications of excessive gaming. We
                  provide and advertise our games as delightful forms of
                  entertainment because we think that only when players play
                  sensibly and in moderation will gaming remain as such.
                </p>
              </ul>
            </div>
          </div>
          <div className="PaymentsIcons">
            <ul>
              <li>
                <a href="javascript:void(0)">
                  <img src={Payments1} alt="payments icon" />
                </a>
              </li>
              <li>
                <a href="javascript:void(0)">
                  <img src={Payments2} alt="payments icon" />
                </a>
              </li>
              <li>
                <a href="javascript:void(0)">
                  <img src={Payments3} alt="payments icon" />
                </a>
              </li>
              <li>
                <a href="javascript:void(0)">
                  <img src={Payments4} alt="payments icon" />
                </a>
              </li>
              <li>
                <a href="javascript:void(0)">
                  <img src={Payments5} alt="payments icon" />
                </a>
              </li>
              <li>
                <a href="javascript:void(0)">
                  <img src={Payments6} alt="payments icon" />
                </a>
              </li>
              <li>
                <a href="javascript:void(0)">
                  <img src={Payments7} alt="payments icon" />
                </a>
              </li>
              <li>
                <a href="javascript:void(0)">
                  <img src={Payments8} alt="payments icon" />
                </a>
              </li>
              <li>
                <a href="javascript:void(0)">
                  <img src={Payments9} alt="payments icon" />
                </a>
              </li>

              <li>
                <a href="javascript:void(0)">
                  <img src={Payments11} alt="payments icon" />
                </a>
              </li>
            </ul>
          </div>
          <div className="LicenseSection d-none">
            <div className="LicenseImg"></div>
            <div>
              <p>
                Play responsibly, age must be above 18. Curacao License No: N.V.
                8048/JAZ
              </p>
              <p> © Copyright 2020. All Rights Reserved.</p>
            </div>
          </div>
          <div className="sectionDivide d-none">
            <div className="singleSection">
              <div className="footer-logo">
                <a href="#">
                  <img src={appDetails?.LOGO_URL || logo} alt="Logo" />
                </a>
                <div className="social-icons">
                  <ul>
                    <li>
                      <a
                        href={
                          appDetails?.FACEBOOK != ""
                            ? appDetails?.FACEBOOK
                            : "javascript:void(0)"
                        }
                        target={appDetails?.FACEBOOK != "" ? "_blank" : ""}
                      >
                        <img src={FbIconImg} />
                      </a>
                    </li>
                    <li>
                      <a
                        href={
                          appDetails?.INSTATGRAM != ""
                            ? appDetails?.INSTATGRAM
                            : "javascript:void(0)"
                        }
                        target={appDetails?.INSTATGRAM != "" ? "_blank" : ""}
                      >
                        <img src={InstaIconImg} />
                      </a>
                    </li>
                    <li>
                      <a
                        href={
                          appDetails?.TELEGRAM != ""
                            ? appDetails?.TELEGRAM
                            : "javascript:void(0)"
                        }
                        target={appDetails?.TELEGRAM != "" ? "_blank" : ""}
                      >
                        <img src={TelegramImg} />
                      </a>
                    </li>
                    <li>
                      <a
                        href={
                          appDetails?.WHATS_APP_URL != ""
                            ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
                            : "javascript:void(0)"
                        }
                        target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
                      >
                        <img src={WhatsaPPImg} />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="foot-discription">
                <p>
                  We are dedicated to making sure you have a great time playing
                  games on www.daddy365.com while also being well aware of the
                  negative social and financial implications of excessive
                  gaming. We provide and advertise our games as delightful forms
                  of entertainment because we think that only when players play
                  sensibly and in moderation will gaming remain as such.
                </p>
              </div>
            </div>
            <div className="singleSection">
              <div className="providers_logo">
                <h4>Gaming Partner</h4>
                <ul>
                  <li>
                    <img src={AppuGames} alt="Providers Logo" />
                  </li>
                  <li>
                    <img src={EvolutionGames} alt="Providers Logo" />
                  </li>
                  <li>
                    <img src={EzugiGames} alt="Providers Logo" />
                  </li>
                </ul>
              </div>
              <div className="paymentspartner">
                <h5>Payments Partners</h5>
                <ul>
                  <li>
                    <img src={UPIcon} />
                  </li>
                  <li>
                    <img src={GooglaPay} />
                  </li>
                  <li>
                    <img src={Paytm} />
                  </li>
                  <li>
                    <img src={Phonepay} />
                  </li>
                  <li>
                    <img src={Bitcoin} />
                  </li>
                  <li>
                    <img src={therthnt} />
                  </li>
                  <li>
                    <img src={pmicon} />
                  </li>
                  <li>
                    <img src={binance} />
                  </li>
                </ul>
              </div>

              <div className="providers_logo SecureLogo">
                <h4>Secure Partner </h4>
                <ul>
                  <li>
                    <a href="">
                      <img src={SecurePartner} />
                      <span>
                        100% SAFE <br></br>Protected connection and encrypted
                        data.
                      </span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="LicenseSection">
              <div className="LicenseImg"></div>
              <div>
                <p>
                  Play responsibly, age must be above 18. Curacao License No:
                  N.V. 8048/JAZ
                </p>
                <p> © Copyright 2020. All Rights Reserved.</p>
              </div>
            </div>
          </div>
        </Container>

        <BottomNav />
      </footer>
    </>
  );
};

export default Footer;
